import React, { FC } from 'react';
import { HtmlProps } from '../Html';
import { PictureProps } from '../Picture';
import * as SC from './styled';
export type RecipeStepProps = {
  className?: string;
  index: string;
  htmlProps: HtmlProps;
  image?: PictureProps;
};
const RecipeStep: FC<RecipeStepProps> = props => {
  const {
    className,
    index,
    htmlProps,
    image
  } = props;
  return <SC.Item className={className}>
      <SC.Wrapper>
        <SC.Index>{index}</SC.Index>
        <SC.Text {...htmlProps} />
      </SC.Wrapper>
      {image && <SC.Image {...image} />}
    </SC.Item>;
};
export default RecipeStep;